// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "fi.dropmate",
    name: "Dropmate",
    homepage: "https://dropmate.fi",
    image_id: "bf19fe4b-d712-45e8-95f2-b7be36e4c400",
    app: {
        browser: null,
        ios: "https://testflight.apple.com/join/KHOMtqE4",
        android: "https://play.google.com/store/apps/details?id=app.dropmate",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "dropmate://app",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map